import React, { useEffect, useState } from 'react';
import {
  spedStudentColumns,
  getSpedStudentProfileListData,
} from './spedStudentsDataGrid';
import Grid from '@mui/material/Grid';
import { useForm } from 'react-hook-form';
import { intialPageSize } from 'constants';
import SpedNoteDialog from './SpedNoteDialog';
import { GridForm } from 'components/Ui/styled';
import {
  setIsBulkSpedNote,
  setSelectedStudents,
} from '../../store/spedNotesSlice/spedNoteSlice';
import { useSelector, useDispatch } from 'react-redux';
import {
  getStudentsProfile,
  getStudentProfileFilterOptions,
} from 'layouts/studentManagement/services/studentProfileApi';
import {
  setDataGridCounts,
  resetDataGridCounts,
} from 'utils/commonSlice/dataGridCounts/dataGridCountsSlice';
import DeltaDataGrid from 'utils/CommonDataGrid/CommonDataGrid';
import { useNotification, getButtonSpinner } from 'utils/commonUtils';
import { getSpedNotesFilterOptions } from '../../services/spedNotesApi';
import FormInputDropdown from 'components/Common/Forms/FormInputDropDown';
import { setInstructor } from 'layouts/applications/attendance/store/semesterSlice';
import { setCourse } from 'layouts/reports/store/reportsFilterSlice/reportsFilterSlice';
import {
  setStudentProfilePagination,
  resetStudentProfilePagination,
  setStudentProfilePaginationPreviousKey,
} from 'layouts/studentManagement/store/studentProfileSlice/studentProfilePaginationSlice';
import {
  setStudentProfileFilterOptions,
  resetStudentProfileFilterOptions,
} from 'layouts/studentManagement/store/studentProfileFilterOptionsSlice/studentProfileFilterOptionsSlice';
import { resetStudentProfileFilter } from 'layouts/studentManagement/store/studentProfileFilterSlice/studentProfileFilterSlice';

function InputByClassTab() {
  const dispatch = useDispatch();
  const {
    setOpenNotification,
    setNotificationMessage,
    NotificationPopup,
    handleErrorResponse,
  } = useNotification();

  const studentProfileFilterOptions = useSelector(
    (state) => state.studentProfileFilterOptions
  );

  const { allInstructors, allCourseNames } = studentProfileFilterOptions ?? [];

  const selectedBulkStudents =
    useSelector((state) => state?.spedNotes?.selectedStudents) || [];

  const dataGridCounts = useSelector(
    (state) => state?.totalDataGridCounts?.dataGridCounts
  );
  const totalNumber = dataGridCounts?.reduce((acc, curr) => acc + curr, 0);

  const studentProfilePagination = useSelector(
    (state) => state?.studentProfilePaginationKeyList?.studentProfilePagination
  );

  const studentProfileFilters = useSelector(
    (state) => state.studentProfileFilters
  );

  const { studentType, instructor, course, gradeLevel } = studentProfileFilters;

  const [studentList, setStudentList] = useState({
    isLoading: false,
    rows: [],
    pageSize: intialPageSize,
    page: 1,
    total: 3000,
    currentPaginationKey: '',
    nextPaginationKey: '',
    count: '',
  });
  const { pageSize, page, nextPaginationKey, count } = studentList;

  const [selectedIds, setSelectedIds] = useState([]);
  const [filterOptions, setfilterOptionss] = useState(null);
  const [studentsPageKey, setStudentsPageKey] = useState('');
  const [openBulkSpedNote, setOpenBulkSpedNote] = useState(false);

  useEffect(() => {
    getFilterOptions();
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setSelectedStudents([]));
    };
  }, []);

  useEffect(() => {
    dispatch(setSelectedStudents([]));
  }, []);

  const getFilterOptions = async () => {
    try {
      const filterOptions = await getSpedNotesFilterOptions();
      setfilterOptionss(filterOptions);
    } catch (error) {
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const handleToggleSelect = (id, checked) => {
    setSelectedIds((prev) => {
      const updated = checked
        ? [...prev, id]
        : prev.filter((item) => item !== id);
      dispatch(setSelectedStudents(updated));
      return updated;
    });
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      const allIds = studentList.rows.map((r) => r.id);
      setSelectedIds(allIds);
      dispatch(setSelectedStudents(allIds));
    } else {
      setSelectedIds([]);
      dispatch(setSelectedStudents([]));
    }
  };

  const defaultValue = {
    instructor: instructor,
    course: course,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
  });

  const { reset, control, register, watch } = useFunction;

  useEffect(() => {
    getStudentProfileFilterOptionsData();
  }, []);

  const watchedInstructor = watch('instructor');
  const watchedCourse = watch('course');

  useEffect(() => {
    fetchStudents();
  }, [pageSize, studentsPageKey, watchedInstructor, watchedCourse]);

  const getStudentProfileFilterOptionsData = async () => {
    try {
      const studentProfileFilterOptionsData =
        await getStudentProfileFilterOptions();
      dispatch(setStudentProfileFilterOptions(studentProfileFilterOptionsData));
    } catch (error) {
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    return () => {
      setStudentList((prevState) => ({
        ...prevState,
        rows: [],
      }));
      dispatch(resetStudentProfileFilter());
      dispatch(resetStudentProfileFilterOptions());
    };
  }, []);

  useEffect(() => {
    if (page === 1) {
      dispatch(resetStudentProfilePagination());
      dispatch(resetDataGridCounts());
      dispatch(setDataGridCounts(pageSize));
    }
  }, []);

  const fetchStudents = async () => {
    setStudentList({ ...studentList, isLoading: true });
    try {
      const studentsListData = await getStudentsProfile(
        pageSize,
        studentsPageKey,
        studentType,
        watchedInstructor,
        watchedCourse,
        gradeLevel
      );
      setStudentList({ ...studentList, isLoading: false });
      setStudentList({
        ...studentList,
        currentPaginationKey: studentsListData?.currentPaginationKey,
        nextPaginationKey: studentsListData?.nextPaginationKey,
        count: studentsListData?.count,
      });
      setStudentList((prev) => ({
        ...prev,
        rows: getSpedStudentProfileListData(studentsListData),
      }));
    } catch (error) {
      setOpenNotification(true);
      setNotificationMessage(error?.response?.data?.message);
      setStudentList({ ...studentList, isLoading: false });
    }
  };

  useEffect(() => {
    if (!studentList?.isLoading) {
      if (count < pageSize) {
        setStudentList((prveState) => ({
          ...prveState,
          total: totalNumber,
        }));
      }
    }
  }, [count, pageSize]);

  const handelPageChange = (page) => {
    setStudentList((prveState) => ({
      ...prveState,
      page: page + 1,
    }));
    const paginationIdValue = {
      id: page,
      value: nextPaginationKey,
    };
    if (studentProfilePagination?.find((item) => item.id === page)) {
      const getPreviousPaginationKey = () => {
        const getPaginationKey = studentProfilePagination?.find(
          (item) => item?.id === page
        );
        return getPaginationKey?.value;
      };
      const previousPaginationKey = getPreviousPaginationKey();
      dispatch(setStudentProfilePaginationPreviousKey(previousPaginationKey));
      setStudentsPageKey(previousPaginationKey);
    } else {
      dispatch(setDataGridCounts(count));
      dispatch(setStudentProfilePagination(paginationIdValue));
      setStudentsPageKey(nextPaginationKey);
    }
    if (page < 1) {
      setStudentList((prveState) => ({
        ...prveState,
        total: 3000,
      }));
      dispatch(resetStudentProfilePagination());
      dispatch(resetDataGridCounts());
      dispatch(setDataGridCounts(pageSize));
      setStudentsPageKey('');
    }
  };

  const handleOnPageSizeChange = (newPageSize) => {
    if (count < pageSize) {
      setStudentList((prveState) => ({
        ...prveState,
        pageSize: newPageSize,
        page: 1,
        total: totalNumber,
      }));
    } else {
      setStudentList((prveState) => ({
        ...prveState,
        pageSize: newPageSize,
        page: 1,
        total: 3000,
      }));
      dispatch(resetStudentProfilePagination());
      dispatch(resetDataGridCounts());
      dispatch(setDataGridCounts(newPageSize));
    }
  };

  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue.instructor, defaultValue.course]);

  const allInstructorsOptions = allInstructors?.map((item) => ({
    id: item,
    value: item,
  }));

  const allCourseNamesOptions = allCourseNames?.map((item) => ({
    id: item,
    value: item,
  }));

  const resetPaginationState = () => {
    dispatch(resetStudentProfilePagination());
    dispatch(resetDataGridCounts());
    dispatch(setDataGridCounts(pageSize));
    setStudentsPageKey('');
    setStudentList((prev) => ({
      ...prev,
      page: 1,
      total: 3000,
      currentPaginationKey: '',
      nextPaginationKey: '',
    }));
  };

  const clearStudentSelections = () => {
    setSelectedIds([]); // clear local selection
    dispatch(setSelectedStudents([])); // clear Redux selection
  };

  const handleInstructor = (e) => {
    dispatch(setInstructor(e.target.value));
    resetPaginationState();
    clearStudentSelections();
  };

  const handleCourse = (e) => {
    dispatch(setCourse(e.target.value));
    resetPaginationState();
    clearStudentSelections();
  };

  const handleBulkSpedNote = () => {
    setOpenBulkSpedNote(true);
    dispatch(setIsBulkSpedNote(true));
  };

  return (
    <>
      <GridForm container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <FormInputDropdown
            name="instructor"
            type="text"
            control={control}
            options={allInstructorsOptions}
            defaultValue={defaultValue?.instructor}
            label="Instructor"
            register={register('instructor', {
              onChange: (e) => {
                handleInstructor(e);
              },
            })}
            filter
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormInputDropdown
            name="course"
            type="text"
            control={control}
            options={allCourseNamesOptions}
            defaultValue={defaultValue?.course}
            label="Course"
            register={register('course', {
              onChange: (e) => {
                handleCourse(e);
              },
            })}
            filter
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} justifyItems="end">
          {getButtonSpinner(
            false,
            handleBulkSpedNote,
            'New Bulk SPED Note',
            selectedBulkStudents.length < 1
          )}
        </Grid>
      </GridForm>
      <SpedNoteDialog
        open={openBulkSpedNote}
        filterOptions={filterOptions}
        setOpen={setOpenBulkSpedNote}
        setSelectedIds={setSelectedIds}
      />
      <DeltaDataGrid
        listData={studentList}
        columns={spedStudentColumns(
          selectedIds,
          handleToggleSelect,
          handleSelectAll,
          studentList.rows
        )}
        handelPageChange={handelPageChange}
        setListData={handleOnPageSizeChange}
        defaultSortField="lastName"
      />
      <NotificationPopup />
    </>
  );
}

export default InputByClassTab;
